import React, { Fragment, useState } from 'react';
import classnames from 'classnames';
import { SelectionState } from '../constants';

const ResultPart = ({ hideDecommissioned, part }) => {
  const selectionState = part.selectionState();

  const [ isExpanded, setExpanded ] = useState(true);

  const classes = classnames({
    'text-muted': !part.selfSelected,
    'pending': part.selfPending
  });

  const relevantChildren = part.children.filter(
    c => c.selectionState() !== SelectionState.UNSELECTED
  );

  const ulClasses = classnames(
    'fa-ul',
    'collapse',
    {
      'show': isExpanded
    }
  );

  if (part.decommissioned && hideDecommissioned) {
    return null;
  } else {
    return (
      <li className="py-1">
        {
          relevantChildren.length > 0 ?
            <button
              aria-expanded={isExpanded}
              className={classnames('chevron-collapse-button', 'btn', 'btn-sm', { 'collapsed': !isExpanded })}
              onMouseUp={() => setExpanded(!isExpanded)}
              type='button'
            >
              <i className={classnames('text-orange fa', { 'fa-chevron-down': isExpanded, 'fa-chevron-right': !isExpanded })} />
            </button>
            : null
        }
        <span className={classnames('name', classes)}>
          <span
            className={`fa ${part.icon}`}
            title={part.title || part.type}
          />
          <span className="ml-2">{ part.name }</span>
        </span>
        <ul className={ulClasses}>
          {
            relevantChildren.map(
              c => <ResultPart key={`${c.type}-${c.id}`} part={c} hideDecommissioned={hideDecommissioned}/>
            )
          }
        </ul>
      </li>
    );
  }
};

export default ({ selectedComponents, hideDecommissioned }) => {
  return selectedComponents.length ? (
    <Fragment>
      {
        selectedComponents.map(
          part => <ResultPart
            key={`${part.type}-${part.id}`}
            part={part}
            hideDecommissioned={hideDecommissioned}
          />
        )
      }
    </Fragment>
  ) : <li><em>None</em></li>;
}
